import { Box } from '../../../common/ui/Box';
import { PriceBoxContent } from '../PriceBoxContent';
import { theme } from '../../../common/ui/theme';

export const PriceBox = ({ price, contractName, isDefaultContract }) => {
    return (
        <Box
            position="relative"
            paddingTop={16}
            paddingLeft={16}
            paddingRight={16}
            width="240px"
            height="220px"
            borderRadius="4px"
            border="1px solid"
            borderColor="border.muted"
            boxShadow={theme.shadows.medium}
        >
            <PriceBoxContent price={price} contractName={contractName} isDefaultContract={isDefaultContract} />
        </Box>
    );
};
